import { createSelector } from 'reselect'

const newFavorite = state => state.favorite.newFavorite

export const getNewFavorite = createSelector([newFavorite], newFavorite => newFavorite)

const favorites = state => state.favorite.favorites

export const getFavorites = createSelector([favorites], favorites => favorites)
